<template>
  <div>
    <header-bar>管理者様へのお知らせ</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">お知らせ一覧</h3>
      </div>
      <div class="page-block__inner">
        <div class="news-list-area">
          <div class="news-list__count">
            <span class="news-list__count-all">全て : {{ pagination.total }}件</span>
            <span class="news-list__count-unread">未読 : {{ pagination.unread }}</span>
          </div>
          <ul
            class="news-list">
            <li
              v-for="item in pagination.data"
              :key="item.id"
              class="news-list__node"
              :class="{ 'news-list__node--unread': item.read === 0 }">
              <p class="news-list__date">{{ item.start_date | formatDate }}</p>
              <p class="news-list__title">
                <router-link
                  :to="{ name: 'information-detail', params: { id: item.id } }"
                  class="c-text-link">
                  {{ item.title }}
                </router-link>
              </p>
              <p class="news-list__paragraph">
                {{ item.content | stripTags | heading }}
              </p>
            </li>
          </ul>
          <div class="c-btn-wrap c-btn-wrap--with-pager">
            <pagination
              :pagination="pagination"
              @on-pagination-clicked="onPaginationClicked">
            </pagination>
            <router-link
              :to="{ name: 'index' }"
              class="c-btn c-btn--back c-btn--left">
              戻る
              <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Pagination from '../../../components/Pagination'
import HeaderBar from '../HeaderBar'

export default {
  name: 'InformationIndex',
  components: {
    HeaderBar,
    Pagination,
  },
  data() {
    return {
      pagination: {},
    }
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems(page) {
      const response = await window.axios.get(`/api/client/informations?page=${page}`)
      this.pagination = response.data
    },
    onPaginationClicked(page) {
      this.fetchItems(page)
    },
  },
}
</script>
